import { Info } from 'lucide-react';
import { useState } from 'react';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type Props = { amount: number };

export const EventMatching = ({ amount }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  if (amount === 0) return null;

  return (
    <Tooltip delayDuration={0} open={isOpen} onOpenChange={setIsOpen}>
      <TooltipTrigger
        onClick={() => setIsOpen(!isOpen)}
        className="flex h-8 flex-row items-center gap-1 rounded-[6px] bg-[#F1A32E1A] px-2.5 py-2 text-sm text-[#F1A32E]"
      >
        {amount.toFixed(2)} matching{' '}
        <Info className="color-[#F1A32E] h-3 w-3" />
      </TooltipTrigger>
      <TooltipContent onPointerDownOutside={() => setIsOpen(false)}>
        <p>
          This limit order is priced within the current market,
          <br /> and will fill right away as a market order
        </p>
      </TooltipContent>
    </Tooltip>
  );
};
